import React, { type FC } from 'react';
import { defineMessages } from 'react-intl';

import type { ObjectSidebarPanel } from '@confluence/object-sidebar-api/entry-points/useObjectSidebar.ts';

import { AGENT_TRUST_RECEIPT_PANEL_ID, type AgentTrustReceipt } from './agentTrustReceiptModel.ts';
import { AgentTrustReceiptPanelBody } from './AgentTrustReceiptPanelBody.tsx';

const i18n = defineMessages({
	headerLabel: {
		id: 'agent-trust-receipt.panel.header',
		defaultMessage: 'Agent receipt',
		description: 'Object sidebar panel header for the Agent Trust Receipt feature.',
	},
});

type CreateAgentTrustReceiptPanelOptions = {
	receipt: AgentTrustReceipt;
};

type AgentTrustReceiptPanelBodyComponentProps = {
	receipt: AgentTrustReceipt;
};

const AgentTrustReceiptBodyComponent: FC<AgentTrustReceiptPanelBodyComponentProps> = ({
	receipt,
}) => <AgentTrustReceiptPanelBody receipt={receipt} />;

export const createAgentTrustReceiptPanel = ({
	receipt,
}: CreateAgentTrustReceiptPanelOptions): ObjectSidebarPanel => ({
	id: AGENT_TRUST_RECEIPT_PANEL_ID,
	headerComponentElements: {
		headerLabel: i18n.headerLabel,
	},
	BodyComponent: AgentTrustReceiptBodyComponent as ObjectSidebarPanel['BodyComponent'],
	props: { receipt } as ObjectSidebarPanel['props'],
});
